import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Constants} from "../../constants";
import {environment} from "../../environments/environment";
import {Membership} from "../../models/membership";

@Injectable({
  providedIn: 'root'
})
export class MembershipService {

  constructor(private http: HttpClient) {
  }

  getRequestHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken
    });
  }

  getPublicRequestHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': environment.publicApiToken,
    });
  }

  async createMembership(membership: Membership){
    let response: any;

    try {
      response = await this.http.post(environment.apiUrl + '/memberships', membership, {headers: this.getRequestHeaders()}).toPromise();
    } catch (e) {
      console.error('createMembership error: ', e)
    } finally {
      return response;
    }
  }

  async sendNotification(athleteId: string | undefined){
    let response: any;
    try {
      response = await this.http.post(environment.apiUrl + `/memberships/notification/${athleteId}`, {},{headers: this.getRequestHeaders()}).toPromise();
    } catch (e) {
      console.error('createMembership error: ', e)
    } finally {
      return response;
    }
  }
}
